import {
    Badge,
    Tooltip,
} from '@mantine/core';
import {TestRunStatus} from '../types.ts';
// The colours and the FAILED-vs-ABANDONED wording live in ./statusConfig so they
// can be asserted by tests and reused by the legend. See that file before
// changing any colour here.
import {STATUS_CONFIG} from './statusConfig.ts';

export const TestRunStatusBadge = ({status}: { status?: TestRunStatus }) => {

    if (!status) {
        return <Badge color='dark'>Invalid Status</Badge>;
    }

    const config = STATUS_CONFIG[status];
    if (!config) {
        return <Badge color='dark'>{status}</Badge>;
    }

    return (
        <Tooltip
            label={config.description}
            multiline
            w={280}
            withArrow
        >
            <Badge
                color={config.color}
                // ABANDONED is additionally given an outline variant so the two
                // are distinguishable without relying on colour alone — colour is
                // not an accessible channel on its own, and this is precisely the
                // distinction a colour-blind operator must not lose.
                variant={status === TestRunStatus.ABANDONED ? 'outline' : 'filled'}
            >
                {config.label}
            </Badge>
        </Tooltip>
    );
};
